class OaklenPageSeriesGrid extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.grid = this.querySelector('[data-oaklen-series-grid-items]');
    this.cards = Array.from(this.querySelectorAll('[data-oaklen-series-card]'));
    this.handleSortChange = this.handleSortChange.bind(this);

    document.addEventListener('oaklen:sort-change', this.handleSortChange);

    this.dispatchResultsChange();
  }

  disconnectedCallback() {
    document.removeEventListener('oaklen:sort-change', this.handleSortChange);
  }

  handleSortChange(event) {
    if (!this.matchesTarget(event.detail?.target)) return;

    this.sortCards(event.detail.value);
  }

  matchesTarget(target) {
    if (!target) return false;

    if (this.id && this.normalizeTarget(target) === `#${this.id}`) return true;

    try {
      return this.matches(target);
    } catch {
      return false;
    }
  }

  sortCards(sortValue) {
    if (!this.grid) return;

    const sortedCards = [...this.cards];

    sortedCards.sort((a, b) => {
      if (sortValue === 'price-low-to-high') {
        return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
      }

      if (sortValue === 'price-high-to-low') {
        return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
      }

      if (sortValue === 'newest') {
        return Number(b.dataset.index || 0) - Number(a.dataset.index || 0);
      }

      return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
    });

    sortedCards.forEach((card) => this.grid.appendChild(card));
    this.cards = sortedCards;
    this.dispatchResultsChange();
  }

  dispatchResultsChange() {
    this.dispatchEvent(
      new CustomEvent('oaklen:results-change', {
        bubbles: true,
        detail: {
          target: `#${this.id}`,
          count: this.cards.length,
        },
      })
    );
  }

  normalizeTarget(target) {
    if (!target) return '#grid';

    const trimmed = String(target).trim();
    return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  }
}

if (!customElements.get('oaklen-page-series-grid')) {
  customElements.define('oaklen-page-series-grid', OaklenPageSeriesGrid);
}
